import { EnvironmentSelectorState } from './reducer'
import { Environment } from '../../remote-api/models'
import selectorSelectors from '../redux/selector/selectors'

export const environmentSelectorSelectors = <S>(getAll: (state: S) => EnvironmentSelectorState) => {
  return {
    ...selectorSelectors<Environment, S>(getAll),
    getAll: (state: S) => getAll(state)
  }
}
